import { localDate } from '@/helpers/general';
import { DashboardLayout } from '@/platform/layouts';
import {
    Badge,
    Button,
    Container,
    Header,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Segment,
} from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import DOMPurify from 'dompurify';

const ShowView = () => {
    const { action } = usePage().props;

    return (
        <Container fluid>
            <Segment>
                <Modal open={true} onClose={() => window.history.back()}>
                    <ModalHeader>
                        {`${action?.deadline ? 'Actie' : 'Notitie'} detail`}
                    </ModalHeader>
                    <ModalContent>
                        {action?.deadline && (
                            <Badge color='blue'>
                                {localDate(action.deadline)}
                            </Badge>
                        )}
                        <Header as='h4'>{action?.subject || ''}</Header>
                        <p className='mb-4 text-gray-500'>
                            {action?.customer?.id
                                ? `${action?.customer?.customer_number} | ${action?.customer?.name}`
                                : ''}
                            {action?.created_by
                                ? ` | ${action?.created_by?.name}`
                                : ''}
                        </p>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                    action?.action?.replace(/\n/g, '<br />')
                                ),
                            }}
                        />
                    </ModalContent>
                    <ModalActions>
                        <Button onClick={() => window.history.back()}>
                            Sluiten
                        </Button>
                    </ModalActions>
                </Modal>
            </Segment>
        </Container>
    );
};

ShowView.layout = page => <DashboardLayout>{page}</DashboardLayout>;

export default ShowView;
